import { c as _c } from "react-compiler-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import { Button as AriaButton } from "react-aria-components";
import { icon } from "../icon.css.js";
import { XClose } from "../icons/line.js";
import { button, closeIcon } from "./CloseX.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const sizeToIconSize = {
  xs: "xs",
  s: "m",
  m: "m",
  l: "l"
};
const BaseCloseX = (t0, ref) => {
  const $ = _c(19);
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      size: t1,
      type: t2,
      variant: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  const size = t1 === undefined ? "s" : t1;
  const type = t2 === undefined ? "square" : t2;
  const variant = t3 === undefined ? "primary" : t3;
  let t4;
  if ($[5] !== size || $[6] !== type || $[7] !== variant) {
    t4 = button({
      variant,
      size,
      type
    });
    $[5] = size;
    $[6] = type;
    $[7] = variant;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = sizeToIconSize[size];
  let t6;
  if ($[9] !== t5 || $[10] !== variant) {
    t6 = clsx(icon({
      size: t5
    }), closeIcon({
      variant
    }));
    $[9] = t5;
    $[10] = variant;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = /*#__PURE__*/_jsx(XClose, {
      className: t6
    });
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== props || $[15] !== ref || $[16] !== t4 || $[17] !== t7) {
    t8 = /*#__PURE__*/_jsx(AriaButton, {
      ref: ref,
      ...props,
      className: t4,
      children: t7
    });
    $[14] = props;
    $[15] = ref;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export const CloseX = /*#__PURE__*/forwardRef(BaseCloseX);
//# sourceMappingURL=CloseX.js.map